import { date_dmy_func, getFixedNumber } from "../../../components/Common/CommonFunction";


// original
export const columns_1 = [
    "Item Name",
    "Quantity",
    "Rate",
    "Amount"
];



export const PageHedercolumns = [
    "Billed by",
    "Billed to",
    ''
]
export const Footercolumn = [
    "",
]

export const BilledBy = [
    "",
    "",

]
export const BilledTo = [
    "Billed by",
]
export const DetailsOfTransport = [
    "Billed by",
]


export const Rows_1 = (data) => {

    const { Items } = data;
    Items.sort((firstItem, secondItem) => firstItem.GSTPercentage - secondItem.GSTPercentage);

    const returnArr = [];
    let TotalQuantity = 0;

    const TotalItemlength = Object.values(Items).length;
    Items["TotalItemlength"] = TotalItemlength;

    Items.forEach((element, key) => {
        const tableitemRow = [
            `${element.ItemName}`,
            `${(getFixedNumber(element.TotalQuantity, 2)).toFixed(2)}`,
            `${(getFixedNumber(element.Rate, 2)).toFixed(2)}`,
            `${(getFixedNumber(element.TotalAmount, 2)).toFixed(2)}`,
        ];
        TotalQuantity = TotalQuantity + Number(element.TotalQuantity);
        returnArr.push(tableitemRow)



    })
    // if (returnArr.length - 1) {
    //     returnArr.push([
    //         `Previous Opening Balance`,
    //         `Span`,
    //         `${data.PreviousOpeningBalance === null ? "0.00" : (getFixedNumber(data.PreviousOpeningBalance, 2)).toFixed(2)}`,
    //         ``,
    //     ]);
    // }

    // if (returnArr.length - 1) {
    //     returnArr.push([
    //         `Current Closing Balance`,
    //         `Span`,
    //         `${data.CurrentClosingBalance === null ? "0.00" : (getFixedNumber(data.CurrentClosingBalance, 2)).toFixed(2)}`,
    //         ``,
    //     ]);
    // }

    // if (returnArr.length - 1) {
    //     returnArr.push([
    //         `Total Receipt Amount`,
    //         `Span`,
    //         `${data.TotalReceiptAmount === null ? "0.00" : (getFixedNumber(data.TotalReceiptAmount, 2)).toFixed(2)}`,
    //         ``,
    //     ]);
    // }

    if (returnArr.length - 1) {
        returnArr.push([
            `Billed Amount`,
            `${TotalQuantity === null ? "0.00" : (getFixedNumber(TotalQuantity, 2)).toFixed(2)}`,
            `${data.TotalBilledAmount === null ? "0.00" : (getFixedNumber(data.TotalBilledAmount, 2)).toFixed(2)}`,
            `Span`,
        ]);
    }

    // if (returnArr.length - 1) {
    //     returnArr.push([
    //         `Final Amount`,
    //         `Span`,
    //         `${data.FineAmount === null ? "0.00" : (getFixedNumber(data.FineAmount, 2)).toFixed(2)}`,
    //         ``,
    //     ]);
    // }
    return returnArr;
}



export const ReportFotterColumns = [
    "SGST",
    "CGST", "Quantity",
    "GST % ",
    "TaxbleAmt.", "IGST", "Total Amt"
];

export const ReportFotterColumns2 = [
    "SGST",
];

export const ReportRows = (data, doc) => {

    const terms = data.OrderTermsAndCondition
    const slicedArray = terms?.slice(0, 2);
    var TableArray = [["Terms And Condition"],
    [`${slicedArray?.[0] === undefined ? "" : slicedArray[0]?.TermsAndCondition}`,
    ],
    [`${slicedArray?.[1] === undefined ? "" : slicedArray[1]?.TermsAndCondition}`,
    ],
    ]

    return TableArray

}

export const BilledByRow = (data) => {
    var BilledByArray = [
        [`                  ${data.PartyName}`, `                                                      ${data.PreviousOpeningBalance === null ? "0.00" : (getFixedNumber(data.PreviousOpeningBalance, 2)).toFixed(2)}`,],
        [`                        ${data.CustomerName}`, `                                                    ${data.CurrentClosingBalance === null ? "0.00" : (getFixedNumber(data.CurrentClosingBalance, 2)).toFixed(2)}`,],
        [`                ${date_dmy_func(data.FromDate)} To ${date_dmy_func(data.ToDate)}`, `                                                 ${data.TotalBilledAmount === null ? "0.00" : (getFixedNumber(data.TotalBilledAmount, 2)).toFixed(2)}`,],
        [``, `                                  ${data.FineAmount === null ? "0.00" : (getFixedNumber(data.FineAmount, 2)).toFixed(2)}`,],
    ]
    return BilledByArray;
}











